(function () {
  'use strict';

  function initCarousel(root) {
    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length === 0) return;

    const prevBtns = Array.from(root.querySelectorAll('[data-hero-prev]'));
    const nextBtns = Array.from(root.querySelectorAll('[data-hero-next]'));
    const indicators = Array.from(root.querySelectorAll('[data-hero-indicator]'));
    const counter = root.querySelector('[data-hero-counter]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = root.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Number(root.dataset.interval) || 8000;

    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    let timer = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;

    function syncSlideAccess(slide, isActive) {
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      const hit = slide.querySelector('.inga-hero__hit');
      if (hit && hit.tagName === 'A') {
        hit.tabIndex = isActive ? 0 : -1;
      }
    }

    function updateCounter() {
      if (!counter) return;
      const current = String(index + 1).padStart(2, '0');
      const total = String(slides.length).padStart(2, '0');
      counter.textContent = `${current} / ${total}`;
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        syncSlideAccess(slide, i === index);
      });
      indicators.forEach((indicator, i) => {
        indicator.classList.toggle('is-active', i === index);
        indicator.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      updateCounter();
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || slides.length <= 1) return;
      timer = setInterval(next, interval);
    }

    if (slides.length <= 1) {
      syncSlideAccess(slides[0], true);
      updateCounter();
      return;
    }

    prevBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        prev();
        startAutoplay();
      });
    });

    nextBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        next();
        startAutoplay();
      });
    });

    indicators.forEach((indicator) => {
      indicator.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const target = Number(indicator.dataset.heroIndicator);
        if (!Number.isNaN(target)) {
          goTo(target);
          startAutoplay();
        }
      });
    });

    root.addEventListener(
      'touchstart',
      (e) => {
        if (!e.changedTouches[0]) return;
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isSwiping = false;
        stopAutoplay();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchmove',
      (e) => {
        if (!e.changedTouches[0]) return;
        const deltaX = Math.abs(e.changedTouches[0].screenX - touchStartX);
        const deltaY = Math.abs(e.changedTouches[0].screenY - touchStartY);
        if (deltaX > deltaY && deltaX > 12) {
          isSwiping = true;
        }
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      (e) => {
        if (!e.changedTouches[0]) return;
        const deltaX = e.changedTouches[0].screenX - touchStartX;
        const deltaY = Math.abs(e.changedTouches[0].screenY - touchStartY);

        if (isSwiping && Math.abs(deltaX) > 48 && Math.abs(deltaX) > deltaY) {
          if (deltaX > 0) prev();
          else next();
        }

        startAutoplay();
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) startAutoplay();
    });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) startAutoplay();
            else stopAutoplay();
          });
        },
        { threshold: 0.25 }
      );
      visibilityObserver.observe(root);
    }

    updateCounter();
    goTo(index);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
